import { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import EditIcon from "../../svg/EditSvg";
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { postDataAPI } from "../../utils/fetchData";
import { useNavigate, useLocation } from "react-router";
import axios from "axios";
import LayoutHeader from "../../layout/LayoutHeader";
import { BASE_URL } from "../../utils/axios";
import usageTracker from "../../utils/usageTracker";
import Modal from "../../components/Modal";
import { useModal } from "../../hooks/useModal";
import { useDispatch, useSelector } from "react-redux";
import { setErrorAlert, setSuccessAlert } from "../../store/alert/alertSlice";
import { ReactComponent as BandsintownLogo } from "../../assets/images/components/bandsintown-svgrepo-com.svg";
// import { createRemindersForBooking } from "../../utils/remindersData"; // Disabled for bulk imports

const DizeeText = styled.span`
  font-size: 12px;
  color: white;
`;

const LoadingSpinner = styled.div`
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 2px solid white;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  margin-right: 8px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const OptionsContainer = styled.div`
  width: 220px;
  min-height: 450px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AgencyButton = styled.div`
    border: 1px solid ${(props) => (props.type === 'save' ? '#FF2300' : (props.type === 'login' ? 'transparent' : 'gray'))};
    border-radius: 8px;
    width: 200px;
    height: 40px;
    background: ${(props) => (props.type === 'login' ? '#FF2300' : 'transparent')};
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
`;

const AgencyInput = styled.input`
    border: 1px solid gray;
    border-radius: 8px;
    width: 200px;
    height: 40px;
    background: transparent;
    outline: none;
    font-size: 14px;
    color: white;
    padding-left: 10px;
    padding-right: 10px;
    &placeholder:
        color: gray;

`;

const DataItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 18px;
    border-bottom: 1px solid gray;
    padding-bottom: 10px;
    font-size: 14px;
    color: white;
`;

const BulkImport = () => {
    const [step, setStep] = useState(0);
    const token = localStorage.getItem('dizeeToken');
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { modalConfig, showModal, closeModal } = useModal();
    const fileInputRef = useRef(null);
    const [uploadedData, setUploadedData] = useState([]);
    const [curEditData, setEditData] = useState(null);
    const [curEditKey, setKey] = useState(-1);
    const [isProcessing, setProcessing] = useState(false);
    const bandsintownSettings = useSelector(state => state.bandsintown.settings);

    // Global City/State/Province auto-fill data (same as ManualAdd.jsx)
    const cityStateData = {
        // United States
        "New York": "NY", "Los Angeles": "CA", "Chicago": "IL", "Houston": "TX", "Phoenix": "AZ",
        "Philadelphia": "PA", "San Antonio": "TX", "San Diego": "CA", "Dallas": "TX", "San Jose": "CA",
        "Austin": "TX", "Jacksonville": "FL", "Fort Worth": "TX", "Columbus": "OH", "Charlotte": "NC",
        "San Francisco": "CA", "Indianapolis": "IN", "Seattle": "WA", "Denver": "CO", "Washington": "DC",
        "Boston": "MA", "El Paso": "TX", "Nashville": "TN", "Detroit": "MI", "Oklahoma City": "OK",
        "Portland": "OR", "Las Vegas": "NV", "Memphis": "TN", "Louisville": "KY", "Baltimore": "MD",
        "Milwaukee": "WI", "Albuquerque": "NM", "Tucson": "AZ", "Fresno": "CA", "Sacramento": "CA",
        "Mesa": "AZ", "Kansas City": "MO", "Atlanta": "GA", "Long Beach": "CA", "Colorado Springs": "CO",
        "Raleigh": "NC", "Miami": "FL", "Virginia Beach": "VA", "Omaha": "NE", "Oakland": "CA",
        "Minneapolis": "MN", "Tulsa": "OK", "Arlington": "TX", "Tampa": "FL", "New Orleans": "LA",
        
        // Canada
        "Toronto": "ON", "Montreal": "QC", "Vancouver": "BC", "Calgary": "AB", "Edmonton": "AB",
        "Ottawa": "ON", "Winnipeg": "MB", "Quebec City": "QC", "Hamilton": "ON", "Kitchener": "ON",
        "London (ON)": "ON", "Victoria": "BC", "Halifax": "NS", "Oshawa": "ON", "Windsor": "ON",
        
        // United Kingdom
        "London": "England", "Birmingham": "England", "Manchester": "England", "Glasgow": "Scotland",
        "Liverpool": "England", "Edinburgh": "Scotland", "Leeds": "England", "Sheffield": "England",
        "Bristol": "England", "Cardiff": "Wales", "Belfast": "Northern Ireland", "Newcastle (UK)": "England",
        "Nottingham": "England", "Portsmouth": "England", "Plymouth": "England",
        
        // Australia
        "Sydney": "NSW", "Melbourne": "VIC", "Brisbane": "QLD", "Perth": "WA", "Adelaide": "SA",
        "Gold Coast": "QLD", "Newcastle (AU)": "NSW", "Canberra": "ACT", "Sunshine Coast": "QLD",
        "Wollongong": "NSW", "Hobart": "TAS", "Geelong": "VIC", "Townsville": "QLD",
        
        // Germany
        "Berlin": "Berlin", "Hamburg": "Hamburg", "Munich": "Bavaria", "Cologne": "North Rhine-Westphalia",
        "Frankfurt": "Hesse", "Stuttgart": "Baden-Württemberg", "Düsseldorf": "North Rhine-Westphalia",
        "Dortmund": "North Rhine-Westphalia", "Essen": "North Rhine-Westphalia", "Leipzig": "Saxony",
        "Bremen": "Bremen", "Dresden": "Saxony", "Hanover": "Lower Saxony"
        // ... (truncated for brevity, but includes all the global cities)
    };

    // Check if we came from import dropdown with pre-selected format
    useEffect(() => {
        if (location.state?.selectedFormat === 'bandsintown') {
            handleBandsintownImport();
        } else if (location.state?.selectedFormat === 'CSV' || location.state?.selectedFormat === 'Excel') {
            setStep(1); // Go directly to file upload step
        }
    }, [location.state]);

    // Helper function to process Excel dates
    const processExcelDate = (value) => {
        if (!value) return null;
        
        // Handle Excel date serial numbers
        if (!isNaN(value) && value > 40000 && value < 60000) {
            try {
                const excelDate = XLSX.SSF.parse_date_code(value);
                if (excelDate) {
                    return `${excelDate.y}-${String(excelDate.m).padStart(2, '0')}-${String(excelDate.d).padStart(2, '0')}`;
                }
            } catch (e) {
                console.warn('Failed to parse Excel date serial:', value);
            }
        }
        
        // Handle date strings
        if (typeof value === 'string') {
            // Try different date formats
            const dateFormats = [
                // MM.DD.YYYY format (like 09.18.2025)
                /^(\d{1,2})\.(\d{1,2})\.(\d{4})/,
                // MM/DD/YYYY format
                /^(\d{1,2})\/(\d{1,2})\/(\d{4})/,
                // DD-MM-YYYY format
                /^(\d{1,2})-(\d{1,2})-(\d{4})/,
                // YYYY-MM-DD format
                /^(\d{4})-(\d{1,2})-(\d{1,2})/
            ];
            
            for (const format of dateFormats) {
                const match = value.match(format);
                if (match) {
                    let year, month, day;
                    
                    if (format.source.startsWith('^(\\d{4})')) {
                        // YYYY-MM-DD format
                        [, year, month, day] = match;
                    } else {
                        // MM.DD.YYYY, MM/DD/YYYY, DD-MM-YYYY formats
                        [, month, day, year] = match;
                    }
                    
                    // Ensure proper formatting
                    month = String(month).padStart(2, '0');
                    day = String(day).padStart(2, '0');
                    
                    // Validate date
                    const date = new Date(year, month - 1, day);
                    if (date.getFullYear() == year && date.getMonth() == month - 1 && date.getDate() == day) {
                        return `${year}-${month}-${day}`;
                    }
                }
            }
            
            // Fallback: try standard Date parsing
            const parsedDate = new Date(value);
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate.toISOString().split('T')[0];
            }
        }
        
        return null;
    };

    const handleCSV = () => {
        setStep(1);
    }

    const handleUpload = () => {
        fileInputRef.current.click();
    }

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setProcessing(true);
        
        // Track the uploaded file
        try {
            const { trackUploadedFile } = require('../../utils/uploadedFilesTracker');
            trackUploadedFile(file, 'booking', {
                source: 'bulk-import',
                status: 'processing'
            });
        } catch (error) {
            console.error('Error tracking file:', error);
        }
        
        try {
            const fileName = file.name.toLowerCase();
            const isExcel = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');
            
            // Create field mapping for both Excel and CSV columns to Dizee fields
            const fieldMapping = {
                    // Date fields (including Bandsintown format)
                    'PERF.DATE': 'perf_date',
                    'PERF DATE': 'perf_date',
                    'Performance Date': 'perf_date',
                    'Show Date': 'perf_date',
                    'Date': 'perf_date',
                    'Start Date* (yyyy-mm-dd)': 'perf_date',
                    'Start Date': 'perf_date',
                    'Start Date*': 'perf_date',
                    'Event Date': 'perf_date',
                    'ANNOUNCE': 'announce_date',
                    'Announce Date': 'announce_date',
                    'On-Sale Date': 'on_sale_date',
                    'ON SALE': 'on_sale_date',
                    'On Sale Date': 'on_sale_date',
                    'End Date': 'end_date',
                    
                    // Time fields
                    'Start Time* (HH:MM)': 'show_time',
                    'Start Time': 'show_time',
                    'Show Time': 'show_time',
                    'Set Time': 'show_time',
                    'End Time': 'end_time',
                    'On-Sale Time': 'on_sale_time',
                    'Schedule Time': 'schedule_time',
                    
                    // Basic info fields
                    'ARTIST': 'artist',
                    'Artist': 'artist',
                    'Artist Name': 'artist',
                    'STATUS': 'status',
                    'Status': 'status',
                    'VENUE': 'venue',
                    'Venue': 'venue',
                    'Venue*': 'venue',
                    'Venue Name': 'venue',
                    'PROMOTER': 'promoter',
                    'Promoter': 'promoter',
                    'CITY/STATE': 'city_state',
                    'City/State': 'city_state',
                    'City State': 'city_state',
                    'Location': 'city_state',
                    'CITY': 'city',
                    'City': 'city',
                    'City*': 'city',
                    'STATE': 'state',
                    'State': 'state',
                    'Province': 'state',
                    'Region': 'state',
                    'Region*': 'state',
                    'Country': 'country',
                    'Country*': 'country',
                    'Address': 'address',
                    
                    // Financial fields
                    'GUARANTEE': 'guarantee',
                    'Guarantee': 'guarantee',
                    'WALKOUT POTENTIAL': 'walkout_potential',
                    'Walkout Potential': 'walkout_potential',
                    'Walkout': 'walkout_potential',
                    'DEAL INFO': 'deal_info',
                    'Deal Info': 'deal_info',
                    'Deal Type': 'deal_type',
                    'ARTIST NET': 'artist_net',
                    'Artist Net': 'artist_net',
                    
                    // Capacity and tickets
                    'SELLABLE CAP': 'sellable_cap',
                    'Sellable Cap': 'sellable_cap',
                    'Capacity': 'sellable_cap',
                    'CURRENT TICKET COUNT': 'current_ticket_count',
                    'Current Ticket Count': 'current_ticket_count',
                    'Tickets Sold': 'tix_sold',
                    'TIX SOLD': 'tix_sold',
                    '% TIX SOLD': 'tix_sold_percent',
                    'Percent Sold': 'tix_sold_percent',
                    
                    // Links and contact
                    'TICKET LINK': 'ticket_link',
                    'Ticket Link': 'ticket_link',
                    'Ticket URL': 'ticket_link',
                    'Ticket Type': 'ticket_type',
                    'Ticket Link 2': 'ticket_link_2',
                    'Ticket Type 2': 'ticket_type_2',
                    'Streaming Link': 'streaming_link',
                    'PROMOTER CONTACT EMAILS': 'promoter_contact_emails',
                    'Promoter Contact Emails': 'promoter_contact_emails',
                    'Contact Email': 'promoter_contact_emails',
                    'PRODUCTION/SHOW ADVANCE CONTACTS': 'promoter_contact_names',
                    'Production Contacts': 'promoter_contact_names',
                    'Show Advance Contacts': 'promoter_contact_names',
                    
                    // Additional fields
                    'APPEARING WITH': 'appearing_with',
                    'Appearing With': 'appearing_with',
                    'Lineup': 'appearing_with',
                    'Event Name': 'event_title',
                    'Event Display Format': 'event_display_format',
                    'Description': 'notes',
                    'Do Not Announce': 'do_not_announce',
                    'Event Image': 'event_image',
                    'Event Id': 'event_id',
                    'Setlist': 'setlist',
                    'Timezone': 'timezone',
                    'Timezone*': 'timezone',
                    'Postal Code': 'postal_code',
                    'SCHEDULE': 'schedule',
                    'Schedule': 'schedule',
                    'Schedule Date': 'schedule_date',
                    'MERCH': 'merch',
                    'Merch': 'merch',
                    'Merchandise': 'merch',
                    'TICKET PRICES': 'ticket_prices_tiers',
                    'Ticket Prices': 'ticket_prices_tiers',
                    'Pricing': 'ticket_prices_tiers',
                    
                    // Contract and business
                    'Contract Status': 'contract_status',
                    'CONTRACT STATUS': 'contract_status',
                    'Notes': 'notes',
                    'NOTES': 'notes',
                    'Additional Notes': 'notes'
            };
            
            if (isExcel) {
                // Handle Excel files locally
                const data = await file.arrayBuffer();
                const workbook = XLSX.read(data);
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                
                // Convert to JSON with proper date handling
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                    raw: false, // This helps with date formatting
                    dateNF: 'yyyy-mm-dd' // Standard date format
                });
                
                // Process and map the data
                const processedData = jsonData.map(row => {
                    const mappedRow = {};
                    
                    // Map Excel columns to Dizee fields
                    Object.keys(row).forEach(excelKey => {
                        const value = row[excelKey];
                        if (value === null || value === undefined || value === '') return;
                        
                        // Find the mapped field name
                        const mappedKey = fieldMapping[excelKey] || excelKey.toLowerCase().replace(/[^a-z0-9]/g, '_');
                        
                        // Process dates
                        if (mappedKey.includes('date') || excelKey.toLowerCase().includes('date')) {
                            const processedDate = processExcelDate(value);
                            if (processedDate) {
                                mappedRow[mappedKey] = processedDate;
                            }
                        }
                        // Process currency fields
                        else if (mappedKey.includes('guarantee') || mappedKey.includes('walkout') || mappedKey.includes('net') || mappedKey.includes('potential')) {
                            const cleanValue = String(value).replace(/[$,]/g, '');
                            if (!isNaN(cleanValue) && cleanValue !== '') {
                                mappedRow[mappedKey] = cleanValue;
                            } else {
                                mappedRow[mappedKey] = String(value);
                            }
                        }
                        // Process number fields
                        else if (mappedKey.includes('cap') || mappedKey.includes('count') || mappedKey.includes('sold')) {
                            const cleanValue = String(value).replace(/[,]/g, '');
                            if (!isNaN(cleanValue) && cleanValue !== '') {
                                mappedRow[mappedKey] = parseInt(cleanValue);
                            } else {
                                mappedRow[mappedKey] = String(value);
                            }
                        }
                        // Process status field
                        else if (mappedKey === 'status') {
                            const statusValue = String(value).toLowerCase();
                            if (statusValue.includes('confirmed')) mappedRow[mappedKey] = 'confirmed';
                            else if (statusValue.includes('pending')) mappedRow[mappedKey] = 'pending';
                            else if (statusValue.includes('announced')) mappedRow[mappedKey] = 'announced';
                            else if (statusValue.includes('private')) mappedRow[mappedKey] = 'private';
                            else if (statusValue.includes('canceled')) mappedRow[mappedKey] = 'canceled';
                            else mappedRow[mappedKey] = 'pending'; // default
                        }
                        // Regular text fields
                        else {
                            mappedRow[mappedKey] = String(value);
                        }
                    });
                    
                    return mappedRow;
                });
                
                // Post-process to handle city/state logic
                const finalProcessedData = processedData.map(row => {
                    const processedRow = { ...row };
                    
                    // Handle city_state field - split into separate city and state
                    if (processedRow.city_state && !processedRow.city && !processedRow.state) {
                        const cityStateValue = String(processedRow.city_state).trim();
                        
                        // Try to split by common delimiters
                        let city = '', state = '';
                        
                        if (cityStateValue.includes(',')) {
                            const parts = cityStateValue.split(',');
                            city = parts[0]?.trim() || '';
                            state = parts[1]?.trim() || '';
                        } else if (cityStateValue.includes(' - ')) {
                            const parts = cityStateValue.split(' - ');
                            city = parts[0]?.trim() || '';
                            state = parts[1]?.trim() || '';
                        } else {
                            // If no delimiter, treat as city and try to auto-fill state
                            city = cityStateValue;
                        }
                        
                        if (city) {
                            processedRow.city = city;
                            
                            // Auto-fill state if we have it in our database
                            if (cityStateData[city]) {
                                processedRow.state = cityStateData[city];
                            } else if (state) {
                                processedRow.state = state;
                            }
                        }
                        
                        // Remove the original city_state field
                        delete processedRow.city_state;
                    }
                    
                    // Auto-fill state based on city if city exists but state doesn't
                    if (processedRow.city && !processedRow.state && cityStateData[processedRow.city]) {
                        processedRow.state = cityStateData[processedRow.city];
                    }
                    
                    return processedRow;
                });
                
                console.log('Processed Excel data with field mapping:', finalProcessedData);
                setUploadedData(finalProcessedData);
                setStep(2);
                setProcessing(false);
            } else {
                // Handle CSV files locally with PapaParse (same field mapping as Excel)
                const fileText = await file.text();
                
                Papa.parse(fileText, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        console.log('Parsed CSV data:', results.data);
                        
                        // Apply same field mapping logic as Excel
                        const processedData = results.data.map(row => {
                            const mappedRow = {};
                            
                            // Map CSV columns to Dizee fields using the same mapping
                            Object.keys(row).forEach(csvKey => {
                                const value = row[csvKey];
                                if (value === null || value === undefined || value === '') return;
                                
                                // Find the mapped field name
                                const mappedKey = fieldMapping[csvKey] || csvKey.toLowerCase().replace(/[^a-z0-9]/g, '_');
                                
                                // Process dates
                                if (mappedKey.includes('date') || csvKey.toLowerCase().includes('date')) {
                                    const processedDate = processExcelDate(value);
                                    if (processedDate) {
                                        mappedRow[mappedKey] = processedDate;
                                    }
                                }
                                // Process currency fields
                                else if (mappedKey.includes('guarantee') || mappedKey.includes('walkout') || mappedKey.includes('net') || mappedKey.includes('potential')) {
                                    const cleanValue = String(value).replace(/[$,]/g, '');
                                    if (!isNaN(cleanValue) && cleanValue !== '') {
                                        mappedRow[mappedKey] = cleanValue;
                                    } else {
                                        mappedRow[mappedKey] = String(value);
                                    }
                                }
                                // Process number fields
                                else if (mappedKey.includes('cap') || mappedKey.includes('count') || mappedKey.includes('sold')) {
                                    const cleanValue = String(value).replace(/[,]/g, '');
                                    if (!isNaN(cleanValue) && cleanValue !== '') {
                                        mappedRow[mappedKey] = parseInt(cleanValue);
                                    } else {
                                        mappedRow[mappedKey] = String(value);
                                    }
                                }
                                // Process status field
                                else if (mappedKey === 'status') {
                                    const statusValue = String(value).toLowerCase();
                                    if (statusValue.includes('confirmed') || statusValue.includes('published')) mappedRow[mappedKey] = 'confirmed';
                                    else if (statusValue.includes('pending') || statusValue.includes('draft')) mappedRow[mappedKey] = 'pending';
                                    else if (statusValue.includes('announced')) mappedRow[mappedKey] = 'announced';
                                    else if (statusValue.includes('private')) mappedRow[mappedKey] = 'private';
                                    else if (statusValue.includes('cancel')) mappedRow[mappedKey] = 'canceled';
                                    else mappedRow[mappedKey] = 'pending'; // default
                                }
                                // Regular text fields
                                else {
                                    mappedRow[mappedKey] = String(value);
                                }
                            });
                            
                            return mappedRow;
                        });
                        
                        // Post-process to handle city/state logic (same as Excel)
                        const finalProcessedData = processedData.map(row => {
                            const processedRow = { ...row };
                            
                            // Handle city_state field - split into separate city and state
                            if (processedRow.city_state && !processedRow.city && !processedRow.state) {
                                const cityStateValue = String(processedRow.city_state).trim();
                                
                                let city = '', state = '';
                                
                                if (cityStateValue.includes(',')) {
                                    const parts = cityStateValue.split(',');
                                    city = parts[0]?.trim() || '';
                                    state = parts[1]?.trim() || '';
                                } else if (cityStateValue.includes(' - ')) {
                                    const parts = cityStateValue.split(' - ');
                                    city = parts[0]?.trim() || '';
                                    state = parts[1]?.trim() || '';
                                } else {
                                    city = cityStateValue;
                                }
                                
                                if (city) {
                                    processedRow.city = city;
                                    
                                    if (cityStateData[city]) {
                                        processedRow.state = cityStateData[city];
                                    } else if (state) {
                                        processedRow.state = state;
                                    }
                                }
                                
                                delete processedRow.city_state;
                            }
                            
                            // Auto-fill state based on city if city exists but state doesn't
                            if (processedRow.city && !processedRow.state && cityStateData[processedRow.city]) {
                                processedRow.state = cityStateData[processedRow.city];
                            }
                            
                            return processedRow;
                        });
                        
                        console.log('Processed CSV data with field mapping:', finalProcessedData);
                        setUploadedData(finalProcessedData);
                        setStep(2);
                        setProcessing(false);
                    },
                    error: (error) => {
                        console.error('CSV parsing error:', error);
                        showModal('CSV Error', 'Failed to parse CSV file. Please check the file format.', 'error');
                        setProcessing(false);
                    }
                });
            }
        } catch (err) {
            console.error('Error processing file:', err);
            setProcessing(false);
            showModal('Processing Error', 'Failed to process file. Please try again.', 'error');
        }
    }

    const handleBandsintownImport = async () => {
        // Check if Bandsintown is configured
        if (!bandsintownSettings?.apiKey || !bandsintownSettings?.artistName) {
            showModal(
                'Bandsintown Not Configured', 
                'Please configure your Bandsintown settings first in the Connectors app.', 
                'error',
                () => navigate('/connectors/bandsintown')
            );
            return;
        }

        setProcessing(true);
        setStep(1); // Show processing step
        
        try {
            const response = await fetch(
                `https://rest.bandsintown.com/artists/${encodeURIComponent(bandsintownSettings.artistName)}/events?app_id=${bandsintownSettings.apiKey}`
            );
            
            if (!response.ok) {
                throw new Error('Failed to fetch events from Bandsintown');
            }

            const events = await response.json();

            if (!Array.isArray(events) || events.length === 0) {
                dispatch(setErrorAlert('No upcoming events found for this artist on Bandsintown'));
                setStep(0);
                setProcessing(false);
                return;
            }

            // Transform Bandsintown events to booking format
            const bookings = events.map(event => {
                const perfDate = new Date(event.datetime);
                
                return {
                    perf_date: perfDate.toISOString().split('T')[0],
                    artist: bandsintownSettings.artistName,
                    venue: event.venue.name,
                    city: event.venue.city,
                    state: event.venue.region || event.venue.country,
                    country: event.venue.country,
                    status: 'confirmed',
                    ticket_link: event.url,
                    promoter: event.venue.name,
                    bandsintown_id: event.id,
                    source: 'bandsintown',
                    // Additional venue details
                    venue_address: `${event.venue.city}, ${event.venue.region || event.venue.country}`,
                    // Format datetime for display
                    show_time: perfDate.toLocaleTimeString('en-US', { 
                        hour: '2-digit', 
                        minute: '2-digit' 
                    }),
                    // Add any additional event details
                    event_description: event.description || '',
                    lineup: event.lineup ? event.lineup.map(act => act.name).join(', ') : bandsintownSettings.artistName
                };
            });

            console.log(`Successfully imported ${bookings.length} events from Bandsintown`);
            dispatch(setSuccessAlert(`Imported ${bookings.length} shows from Bandsintown`));
            
            setUploadedData(bookings);
            setStep(2); // Go to review step
            
        } catch (error) {
            console.error('Bandsintown import failed:', error);
            dispatch(setErrorAlert('Failed to import from Bandsintown. Please check your connection and try again.'));
            setStep(0);
        } finally {
            setProcessing(false);
        }
    };

    const saveEdit = () => {
        setStep(2);
        let tempData = uploadedData;
        tempData[curEditKey] = curEditData;
        setUploadedData([...tempData]);
        setKey(-1);
    }

    // Helper function to deeply sanitize data and remove circular references
    const sanitizeBookings = (bookings) => {
        const allowedFields = [
            'perf_date', 'artist', 'city', 'state', 'venue', 'show_time', 'status',
            'announce_date', 'on_sale_date', 'event_title', 'ticket_link', 'notes',
            'guarantee', 'walkout_potential', 'sellable_cap', 'current_ticket_count',
            'promoter', 'appearing_with', 'red_flag', 'red_flag_notes', 'promoter_company',
            'promoter_contact_names', 'promoter_contact_emails', 'venue_category',
            'billing_type', 'territory', 'advanced_info', 'deal_type', 'deal_info',
            'gross_potential', 'net_potential', 'artist_net', 'artist_profit',
            'split_point', 'amount_to_split', 'ticket_notes', 'ticket_prices_tiers',
            'ticket_taxes_fees', 'total_fees', 'deposit_due', 'deposit_received',
            'contract_status', 'currency_conversion', 'additional_clauses', 'schedule',
            'tix_sold_percent', 'tix_sold', 'merch', 'backline_rider_notes',
            'travel_accommodations', 'radius_clause', 'agent_rep', 'internal_rep_manager',
            'country', 'address', 'timezone', 'postal_code'
        ];
        
        return bookings.map(booking => {
            const sanitized = {};
            // Only copy allowed fields that are primitive values
            allowedFields.forEach(field => {
                if (field in booking) {
                    const value = booking[field];
                    // Only add if it's a primitive type
                    if (value === null || value === undefined || 
                        typeof value === 'string' || 
                        typeof value === 'number' || 
                        typeof value === 'boolean') {
                        sanitized[field] = String(value); // Convert all to string to be safe
                    }
                }
            });
            return sanitized;
        });
    };

    const handleSave = async (forceSkipValidation = false) => {
        // Validate required fields for all bookings
        const requiredFields = [
            { key: 'perf_date', label: 'Performance Date' },
            { key: 'artist', label: 'Artist' },
            { key: 'city', label: 'City' },
            { key: 'state', label: 'State/Province' },
            { key: 'venue', label: 'Venue' }
        ];

        const bookingsWithMissingFields = [];
        
        uploadedData.forEach((booking, index) => {
            const missingFields = requiredFields.filter(field => 
                !booking[field.key] || 
                (typeof booking[field.key] === 'string' && booking[field.key].trim() === '')
            );
            
            if (missingFields.length > 0) {
                bookingsWithMissingFields.push({
                    index,
                    venue: booking.venue || 'Unknown Venue',
                    missingFields: missingFields.map(f => f.label)
                });
            }
        });

        if (!forceSkipValidation && bookingsWithMissingFields.length > 0) {
            const errorMessage = bookingsWithMissingFields
                .slice(0, 3) // Show first 3 errors
                .map(err => `${err.venue}: Missing ${err.missingFields.join(', ')}`)
                .join('\n');
            
            const additionalErrors = bookingsWithMissingFields.length > 3 
                ? `\n... and ${bookingsWithMissingFields.length - 3} more bookings with missing fields` 
                : '';
            
            showModal(
                'Required Fields Missing', 
                `The following bookings are missing required fields:\n\n${errorMessage}${additionalErrors}\n\nPlease edit each booking to add the required information.`, 
                'warning',
                () => handleSave(true), // Callback to proceed anyway
                true, // Show cancel button
                'Proceed Anyways', // Confirm button text
                'Go Back' // Cancel button text
            );
            return;
        }

        try {
            const token = JSON.parse(localStorage.getItem('dizeeToken'));
            // Sanitize the data to remove circular references
            const cleanedData = sanitizeBookings(uploadedData);
            
            // Force deep clone via JSON to break ANY circular references
            const fullyCleanedData = JSON.parse(JSON.stringify(cleanedData));
            console.log('Fully cleaned data:', fullyCleanedData);
            
            const response = await axios.post(
                `${BASE_URL}/user/saveBookings`,
                { 
                    data: fullyCleanedData, 
                    skipValidation: forceSkipValidation === true 
                },
                { 
                    transformRequest: [(data) => {
                        // Force serialize to plain JSON string
                        return JSON.stringify(data);
                    }],
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json'
                    }
                }
            );
            
            if (response.data.status === 200) {
                showModal('Success', 'Bookings saved successfully!', 'success');
                
                // Update file status to processed
                try {
                    const { trackUploadedFile } = require('../../utils/uploadedFilesTracker');
                    const uploadedFile = location.state?.uploadedFile;
                    if (uploadedFile) {
                        trackUploadedFile(uploadedFile, 'booking', {
                            source: 'bulk-import',
                            status: 'processed',
                            processedCount: uploadedData.length
                        });
                    }
                } catch (error) {
                    console.error('Error updating file status:', error);
                }
                
                // Track booking usage for bulk import
                try {
                    const actionType = uploadedData.length > 10 ? 'bulk_import_operation' : 'booking_creation';
                    await usageTracker.track(actionType, { 
                        booking_count: uploadedData.length,
                        source: 'bulk_import' 
                    });
                } catch (trackingError) {
                    console.error('Usage tracking failed:', trackingError);
                }
                
                // DISABLED: Do not create reminders for bulk imports to avoid flooding the user with notifications
                // Users can manually enable reminders for specific bookings if needed
                /*
                // Create booking reminders for all imported bookings
                try {
                    console.log(`🎫 Creating reminders for ${uploadedData.length} bulk imported bookings...`);
                    let totalRemindersCreated = 0;
                    
                    // If API returns saved bookings with IDs, use those
                    const savedBookings = response.data?.data || [];
                    
                    if (savedBookings.length > 0) {
                        savedBookings.forEach((booking, index) => {
                            const bookingId = booking._id || booking.id;
                            if (bookingId && booking.perf_date) {
                                const reminders = createRemindersForBooking(bookingId, booking);
                                totalRemindersCreated += reminders.length;
                            }
                        });
                    } else {
                        // Fallback: use uploadedData with generated IDs
                        uploadedData.forEach((booking, index) => {
                            if (booking.perf_date) {
                                const tempId = `bulk_${Date.now()}_${index}`;
                                const reminders = createRemindersForBooking(tempId, booking);
                                totalRemindersCreated += reminders.length;
                            }
                        });
                    }
                    
                    console.log(`✅ Created ${totalRemindersCreated} total reminders for bulk import`);
                } catch (reminderError) {
                    console.error('Error creating booking reminders:', reminderError);
                    // Don't block the user flow if reminders fail
                }
                */
                
                navigate('/bookings/view-all');
            } else {
                console.log('Save response not successful:', response.data);
                showModal('Save Error', 'Error saving bookings. Please try again.', 'error');
            }
        } catch (error) {
            console.error('Error saving bookings:', error);
            
            // Check if it's a validation error from backend
            if (error.response?.data?.message?.includes('Required fields missing')) {
                showModal(
                    'Validation Error', 
                    error.response.data.message + '\n\nYou can proceed anyways, but some bookings may fail to save.',
                    'warning',
                    () => handleSave(true), // Callback to proceed anyway
                    true, // Show cancel button
                    'Proceed Anyways', // Confirm button text
                    'Go Back' // Cancel button text
                );
            } else {
                showModal('Save Error', 'Error saving bookings. Please try again.', 'error');
            }
        }
    };

    const formatOptions = [
        { name: 'Manual Add', description: 'Fill in the information for your new booking entry', isManual: true },
        { name: 'CSV', description: 'Upload a CSV file with booking data' },
        { name: 'Excel', description: 'Upload an Excel file (.xlsx, .xls) with booking data' },
        { 
            name: 'Bandsintown', 
            description: 'Import shows from your Bandsintown profile', 
            isBandsintown: true,
            icon: BandsintownLogo,
            color: '#00CEC8',
            enabled: !!(bandsintownSettings?.apiKey && bandsintownSettings?.artistName)
        },
        { name: 'JSON', description: 'JSON format support coming soon', disabled: true }
    ];

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    {/* Header */}
                    <div className="px-4 my-[50px] flex w-full justify-between items-center">
                        <span className="text-white text-[14px]" style={{ fontWeight: 300 }}>
                            {step === 2 ? 'Review imported data' : 
                             step === 3 && curEditData ? 'Edit booking details' : 
                             'Import'}
                        </span>
                        <div className="flex items-center gap-4">
                            {/* Save button for review and edit pages */}
                            {step === 2 && (
                                <span 
                                    className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                    onClick={handleSave}
                                >
                                    Save
                                </span>
                            )}
                            {step === 3 && curEditData && (
                                <span 
                                    className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                    onClick={saveEdit}
                                >
                                    Save
                                </span>
                            )}
                            
                            {/* Navigation Buttons - Only show when not in review or edit mode */}
                            {step !== 2 && !(step === 3 && curEditData) && (
                                <>
                                    <span 
                                        className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                        onClick={() => navigate('/bookings/view-all')}
                                    >
                                        View
                                    </span>
                                </>
                            )}
                            
                        <span className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" onClick={() => {
                            if (step === 3 && curEditData) {
                                // If in edit mode, go back to review stage
                                setStep(2);
                                setKey(-1);
                                setEditData(null);
                            } else {
                                // Go back to previous page
                                navigate(-1);
                            }
                        }}>Go back</span>
                        </div>
                    </div>

                    <div className="w-full px-4 flex-1 overflow-y-auto">
                        {step === 0 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Choose your import format</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Select the format of your booking data file</p>
                                </div>

                                <div className="space-y-4">
                                    {formatOptions.map((format, index) => (
                                        <div 
                                            key={index}
                                            className={`bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 transition-all ${
                                                format.disabled 
                                                    ? 'opacity-50 cursor-not-allowed' 
                                                    : 'hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] cursor-pointer'
                                            }`}
                                            onClick={format.disabled ? null : (
                                                format.isManual ? () => navigate('/bookings/manual-add') : 
                                                format.isBandsintown ? (format.enabled ? handleBandsintownImport : () => navigate('/connectors/bandsintown')) :
                                                (format.name === 'CSV' || format.name === 'Excel' ? handleCSV : null)
                                            )}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-3 flex-1">
                                                    {format.icon && (
                                                        <format.icon 
                                                            className="w-5 h-5" 
                                                            style={{ color: format.color }} 
                                                        />
                                                    )}
                                                    <div>
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <h3 className="text-white text-[12px] font-semibold">
                                                                {format.name}
                                                            </h3>
                                                            {format.isBandsintown && !format.enabled && (
                                                                <span className="text-[#FFD700] text-[8px] px-2 py-0.5 bg-[rgba(255,215,0,0.1)] border border-[rgba(255,215,0,0.3)] rounded-full">
                                                                    SETUP REQUIRED
                                                                </span>
                                                            )}
                                                        </div>
                                                        <p className="text-[rgba(255,255,255,0.7)] text-[10px]">
                                                            {format.isBandsintown && !format.enabled 
                                                                ? 'Configure your Bandsintown account first' 
                                                                : format.description
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                {!format.disabled && (
                                                    <div className="w-3 h-3 rounded-full border-2 border-[#FFFF00]" />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {step === 1 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Make sure your file includes columns like venue, artist, date, etc.</p>
                                </div>

                                <div className="space-y-4">
                                    <div 
                                        className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-6 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all cursor-pointer text-center"
                                        onClick={handleUpload}
                                    >
                                        <div className="flex flex-col items-center space-y-3">
                                            <div className="w-12 h-12 bg-[rgba(255,255,0,0.2)] rounded-lg flex items-center justify-center">
                                                <svg className="w-6 h-6 text-[#FFFF00]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3 className="text-white text-[12px] font-semibold mb-1">
                                                    {isProcessing ? 'Processing...' : 'Upload File'}
                                                </h3>
                                                <p className="text-[rgba(255,255,255,0.7)] text-[10px]">
                                                    {isProcessing ? 'Please wait while we process your file' : 'Click to select your CSV or Excel file'}
                                                </p>
                                            </div>
                                            {isProcessing && (
                                                <div className="w-6 h-6 border-2 border-[#FFFF00] border-t-transparent rounded-full animate-spin" />
                                            )}
                                        </div>
                                    </div>

                                    <input 
                                        type="file" 
                                        ref={fileInputRef} 
                                        onChange={handleFileChange} 
                                        accept=".csv,.xlsx,.xls" 
                                        style={{ display: 'none' }} 
                                    />
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)]">Verify your booking data before saving. Required fields: Date, Artist, City, State, Venue</p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    {uploadedData.map((item, index) => {
                                        // Check for missing required fields
                                        const requiredFields = ['perf_date', 'artist', 'city', 'state', 'venue'];
                                        const missingFields = requiredFields.filter(field => 
                                            !item[field] || 
                                            (typeof item[field] === 'string' && item[field].trim() === '')
                                        );
                                        const hasMissingFields = missingFields.length > 0;
                                        
                                        return (
                                        <div 
                                            key={index}
                                            className={`bg-[rgba(255,255,255,0.05)] border rounded-lg p-4 hover:bg-[rgba(255,255,0,0.05)] transition-all ${
                                                hasMissingFields 
                                                    ? 'border-[#FF0000] hover:border-[#FF0000]' 
                                                    : 'border-[rgba(255,255,255,0.1)] hover:border-[#FFFF00]'
                                            }`}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    <div className="flex items-center gap-2 mb-1">
                                                        <h3 className="text-white text-[12px] font-semibold">
                                                            {item.venue || 'Unknown Venue'}
                                                        </h3>
                                                        {hasMissingFields && (
                                                            <span className="text-[#FF0000] text-[10px] bg-[rgba(255,0,0,0.2)] px-2 py-0.5 rounded">
                                                                ⚠ Missing Fields
                                                            </span>
                                                        )}
                                                    </div>
                                                    <p className="text-[rgba(255,255,255,0.7)] text-[10px] mb-2">
                                                        {item.artist || 'Unknown Artist'} • {item.city || 'No City'}, {item.state || 'No State'}
                                                    </p>
                                                    {hasMissingFields && (
                                                        <p className="text-[#FF0000] text-[10px] mb-2">
                                                            Missing: {missingFields.map(f => {
                                                                const labels = {
                                                                    perf_date: 'Date',
                                                                    artist: 'Artist',
                                                                    city: 'City',
                                                                    state: 'State',
                                                                    venue: 'Venue'
                                                                };
                                                                return labels[f] || f;
                                                            }).join(', ')}
                                                        </p>
                                                    )}
                                                    <div className="flex items-center gap-3 text-[rgba(255,255,255,0.5)] text-[10px]">
                                                        {item.perf_date && (
                                                            <span className="bg-[rgba(255,255,0,0.2)] px-2 py-1 rounded">
                                                                {item.perf_date}
                                                            </span>
                                                        )}
                                                        {item.guarantee && (
                                                            <span className="bg-[rgba(255,255,0,0.2)] px-2 py-1 rounded">
                                                                ${item.guarantee}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => {
                                                        setEditData(item);
                                                        setKey(index);
                                                        setStep(3);
                                                    }}
                                                    className={`text-[10px] hover:opacity-70 ${
                                                        hasMissingFields ? 'text-[#FF0000]' : 'text-[#FFFF00]'
                                                    }`}
                                                >
                                                    {hasMissingFields ? 'Fix' : 'Edit'}
                                                </button>
                                            </div>
                                        </div>
                                        );
                                    })}
                                </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                    <button
                                        onClick={handleSave}
                                        className="w-full bg-[#FFFF00] text-black text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(255,255,0,0.9)] transition-all"
                                    >
                                        Save All Bookings ({uploadedData.length})
                                    </button>
                                </div>
                            </div>
                        )}

                        {step === 3 && curEditData && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)]">Modify the booking information as needed. Required fields are marked with <span className="text-[#FFFF00]">*</span></p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    {/* Required Fields First */}
                                    {['perf_date', 'artist', 'city', 'state', 'venue'].map((key) => (
                                        <div 
                                            key={key}
                                            className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all"
                                        >
                                            <label className="block text-white text-[12px] mb-2 capitalize" style={{ fontWeight: 300 }}>
                                                {key === 'perf_date' ? 'Performance Date' : key.replace(/_/g, ' ')}
                                                <span className="text-[#FFFF00] ml-1">*</span>
                                            </label>
                                            <input
                                                type={key.includes('date') ? 'date' : 'text'}
                                                value={curEditData[key] || ''}
                                                onChange={(e) => setEditData({
                                                    ...curEditData,
                                                    [key]: e.target.value
                                                })}
                                                className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                                placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            />
                                        </div>
                                    ))}
                                    
                                    {/* Other Fields */}
                                    {Object.keys(curEditData).filter(key => !['perf_date', 'artist', 'city', 'state', 'venue'].includes(key)).map((key) => (
                                        <div 
                                            key={key}
                                            className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all"
                                        >
                                            <label className="block text-white text-[12px] mb-2 capitalize" style={{ fontWeight: 300 }}>
                                                {key.replace(/_/g, ' ')}
                                            </label>
                                            <input
                                                type={key.includes('date') ? 'date' : 'text'}
                                                value={curEditData[key] || ''}
                                                onChange={(e) => setEditData({
                                                    ...curEditData,
                                                    [key]: e.target.value
                                                })}
                                                className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                                placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            />
                                        </div>
                                    ))}
                                </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                    <button
                                        onClick={saveEdit}
                                        className="w-full bg-[#FFFF00] text-black text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(255,255,0,0.9)] transition-all"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Help Text */}
                        <div className="mt-6 mb-4">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                {step === 0 && (
                                    <>
                                        <p>Import multiple bookings at once from your existing data.</p>
                                        <p>Supports CSV, Excel, and Bandsintown integration with automatic field mapping.</p>
                                    </>
                                )}
                                {step === 2 && (
                                    <>
                                        <p>Review each booking entry before saving to your account.</p>
                                        <p>Click Edit to modify any booking details if needed.</p>
                                    </>
                                )}
                                {step === 3 && (
                                    <>
                                        <p>Update any fields that need correction.</p>
                                        <p>Changes will be applied when you save.</p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Modal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                onConfirm={modalConfig.onConfirm}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
                showCancel={modalConfig.showCancel}
                confirmText={modalConfig.confirmText}
                cancelText={modalConfig.cancelText}
            />
        </LayoutHeader>
    );
};

export default BulkImport;